'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  (0, _index2.default)(app);
  (0, _index4.default)(app);
  (0, _index6.default)(app);
  (0, _index8.default)(app);
};

var _index = require('../pages/bar/index.ctrl');

var _index2 = _interopRequireDefault(_index);

var _index3 = require('../pages/button/index.ctrl');

var _index4 = _interopRequireDefault(_index3);

var _index5 = require('../pages/home/index.ctrl');

var _index6 = _interopRequireDefault(_index5);

var _index7 = require('../pages/common/index.ctrl');

var _index8 = _interopRequireDefault(_index7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

; /**
   * 导入controllers
   */


//////////////////
// WEBPACK FOOTER
// ./src/app/app.controllers.js
// module id = 34
// module chunks = 0